import type { RegisterTranslations } from '../interfaces/register';

export const registerTranslations: RegisterTranslations = {
  register_button: 'Registrar-se',
  create_account_label_prefix: 'Não tem uma conta?',
  create_account_label_button: 'Cadastre-se',
  or_label: 'Ou',
  input_name_label: 'Nome',
  input_name_placeholder: 'Digite seu nome',
  input_last_name_label: 'Sobrenome',
  input_last_name_placeholder: 'Digite seu sobrenome',
  terms_and_conditions_text:
    'Ao se registrar, você concorda com nossos termos e condições',
};
